import N8nUserInfo from './UserInfo.vue';

export default N8nUserInfo;
export type { UsersInfoProps } from './UserInfo.vue';
